import { PresentationChartBarIcon } from '@heroicons/react/outline';

export function PresentationFileIcon() {
  return <PresentationChartBarIcon className="h-full text-file-presentation-enabled" />;
}
